import React, { Component } from 'react';
import Videolist from './../molecules/VideoList';
import InputSearch from './../atoms/InputSearch';
// (removed) import iconYoutube from './../../assets/youtube-symbol.png';
import servicegetVideos from './../../Services/VideosService';
import Loadergift from './../atoms/Loader';
import Textheader from './../atoms/HeaderText';

import './VideosController.css';

const YouTubeMark = ({ className }) => (
  <svg className={className} width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32.3625 3.63233C31.9817 2.20183 30.8633 1.07766 29.4402 0.694736C26.8636 2.20054e-07 16.5268 0 16.5268 0C16.5268 0 6.19007 2.20054e-07 3.61337 0.694736C2.19034 1.07766 1.07204 2.20183 0.691112 3.63233C2.18906e-07 6.22254 0 11.63 0 11.63C0 11.63 2.18906e-07 17.0375 0.691112 19.6277C1.07204 21.0582 2.19034 22.1824 3.61337 22.5652C6.19007 23.26 16.5268 23.26 16.5268 23.26C16.5268 23.26 26.8636 23.26 29.4402 22.5652C30.8633 22.1824 31.9817 21.0582 32.3625 19.6277C33.0537 17.0375 33.0537 11.63 33.0537 11.63C33.0537 11.63 33.0509 6.22254 32.3625 3.63233Z" fill="#FF0000"/>
    <path d="M13.2183 16.5272L21.8055 11.5698L13.2183 6.61224V16.5272Z" fill="white"/>
  </svg>
);

export default class VideoController extends Component {
  constructor(props){
    super(props);
    this.fixedRef = React.createRef();
    this.updatePlaneTop = this.updatePlaneTop.bind(this);
  }

  _raf = null;

  data = {
    videos: [],
    orderByAsc: true,
    searchText: '',
    isFirtsTime: true,
    filterBy: 'Title',
    indexPage: 1,
    response: null,
    statusLoadingIcon: 'none',
    message: '',
    product: 'PartsBase',
  };

  updatePlaneTop = () => {
    if (this._raf) return;

    this._raf = requestAnimationFrame(() => {
      const root = document.documentElement;

      // Ancla: el link de YouTube; fallback por si cambia el DOM
      const anchor =
        document.querySelector('.linkVideos a') ||
        document.querySelector('.FixedpositionSearch') ||
        document.querySelector('.TitleHeader');

      const EXTRA = 86.59; // px, de Figma
      let minTop = 370;    // fallback seguro (valor por defecto)

      if (anchor) {
        const r = anchor.getBoundingClientRect();
        // bottom del link + separación; nunca negativo
        minTop = Math.max(0, Math.round(r.bottom + EXTRA));
      }

      root.style.setProperty('--plane-min-top', `${minTop}px`);
      this._raf = null;
    });
  };


  _getVideos = async (filter) => {
    this.data.message = '';
    this.data.videos = null;
    this.data.statusLoadingIcon = 'block';
    this.setState(this.data);
    const response = await servicegetVideos(filter);
    this.data.statusLoadingIcon = 'none';
    this.setState(this.data);

    this.data.response = response;
    if (!this.data.response.ok) {
      this.data.message = 'Sorry - but we do not have data for this search';
    } else {
      if (this.data.response.data === null)
        this.data.message = 'Sorry - but we do not have data for this search';
      else if (this.data.response.data.items.length === 0)
        this.data.message = 'Sorry - but we do not have data for this search';
    }
    this.data.videos = this.data.response.data !== null ? this.data.response.data.items : null;
    this.setState(this.data);
  };

  async componentDidMount() {
    this.updatePlaneTop();
    window.addEventListener('scroll', this.updatePlaneTop, { passive: true });
    window.addEventListener('resize', this.updatePlaneTop, { passive: true });
    window.addEventListener('load', this.updatePlaneTop);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.updatePlaneTop);
    window.removeEventListener('resize', this.updatePlaneTop);
    window.removeEventListener('load', this.updatePlaneTop);

    if (this._raf) {
      cancelAnimationFrame(this._raf);
    }
  }


  _OnTextChanged = (text) => {
    try {
      this.data.searchText = text;
      this._getVideos(this.data);
    } catch (error) {
      console.log(error);
    }
  };

  _OnFilterChanged = (filterBy, orderByAsc) => {
    try {
      this.data.filterBy = filterBy;
      this.data.orderByAsc = orderByAsc;
      this._getVideos(this.data);
    } catch (error) {
      console.log(error);
    }
  };

  _OnProductChange = (product) => {
    try {
      if (product === 'All products') {
        this.data.product = '';
      } else {
        this.data.product = product;
      }
      this._getVideos(this.data);
    } catch (error) {
      console.log(error);
    }
  };

  _textCleaner = (empty) => {
    this.data.searchText = empty;
  };

  render() {
    const { videos, statusLoadingIcon, message, orderByAsc } = this.data;
    return (
      <div className='VideoController video-page'>
        {/* Capa del avión animada por CSS (transform con --plane-y) */}
        <div className="plane-layer" aria-hidden="true" />

        <div className='containerCentral'>
          <div className='MainContainer'>
            <Textheader></Textheader>
            <div className='InputSearch'>
              <div className='Seccion1'>
                <div className='FixedpositionSearch' ref={this.fixedRef}>
                  <InputSearch
                    onResults={this._OnTextChanged}
                    cleanText={this._textCleaner}></InputSearch>
                  <div className='linkVideos'>
                    <a
                      href='https://www.youtube.com/channel/UCEFgdC9x9ljb3UjlEieqN6g'
                      target='_blank'
                      rel='noopener noreferrer'>
                      Don&apos;t miss out — subscribe to our YouTube channel
                      <YouTubeMark className="ytMark" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className='VideoList'>
              <Videolist
                videos={videos}
                productsFirstTime={this.data.isFirtsTime}
                onSelectedFilter={this._OnFilterChanged}
                onProductFilter={this._OnProductChange}
                message={message}
                orderByAsc={orderByAsc}>
                <Loadergift displayVal={statusLoadingIcon} />
              </Videolist>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
